/**
 * useMeasuredHeight — a view's laid-out height, for layouts that position a
 * sibling relative to it (the mobile glass menu sits at `insets.top + header
 * height`). Starts at `fallback` (the 1x design height) so the first frame is
 * right before onLayout fires; ignores zero measurements.
 */
import { useCallback, useState } from 'react';
import type { LayoutChangeEvent } from 'react-native';

export function useMeasuredHeight(fallback: number): [number, (e: LayoutChangeEvent) => void] {
  const [height, setHeight] = useState(fallback);
  const onLayout = useCallback((e: LayoutChangeEvent) => {
    const h = Math.round(e.nativeEvent.layout.height);
    if (h > 0) setHeight(prev => (prev === h ? prev : h));
  }, []);
  return [height, onLayout];
}
